import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { isStandaloneMode } from '../../../config';
import { keycloakMessage } from '../../../store/keycloak';

export const KeycloakProvider = ({ children }: { children: JSX.Element }) => {
    const dispatch = useDispatch();

    const handleEvent = (event: string | unknown = 'onReady') => dispatch(keycloakMessage({ event: event }));

    /* eslint-disable @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any,react-hooks/exhaustive-deps */
    const handleTokensFromWindow = () =>
        dispatch(
            keycloakMessage({
                tokens: {
                    refreshToken: (window as any).keycloak.refreshToken,
                    token: (window as any).keycloak.token,
                    idToken: (window as any).keycloak.idToken,
                },
            })
        );

    useEffect(() => {
        (window as any).addEventListener('keycloakReadyEvent', () => handleEvent());
        (window as any).addEventListener('djangoTokensRefreshed', handleTokensFromWindow);

        return () => {
            (window as any).removeEventListener('keycloakReadyEvent', () => handleEvent());
            (window as any).removeEventListener('djangoTokensRefreshed', handleTokensFromWindow);
        };
    }, []);

    if (isStandaloneMode) {
        // No login feature exists in standalone Product Finder, and Keycloak requires the deployed
        // origin to be registered on the realm -- skip it entirely rather than issue calls that 403.
        return children;
    }

    (window as any).addEventListener('djangoScriptsReady', () => {
        if ((window as any).keycloakReadyDjango !== true && !(window as any).isKeycloakInitialising) {
            (window as any).checkKeycloakStatus();
        }
    });

    return children;
    /* eslint-enable @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any,react-hooks/exhaustive-deps */
};
